export default "__VITE_ASSET__Dhe8cSbi__"